var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"font-weight-light caption mt-2",attrs:{"wrap":""}},[_c('v-flex',[_vm._v("Última actualización:")]),_c('v-flex',{staticClass:"font-italic text-xs-center"},[_vm._v(_vm._s(_vm.dateString))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }